// ─── Pagination ───────────────────────────────────────────────────────────────
export const DEFAULT_PAGE_SIZE = 10;
export const LIMIT_OPTIONS = [10, 20, 30];

// ─── Table columns ────────────────────────────────────────────────────────────
export const COLUMNS = [
    { key: 'name', label: 'Fund', sortable: true },
    { key: 'vintage', label: 'Vintage', sortable: true },
    { key: 'fundSize', label: 'Funds Raised', sortable: true },
    { key: 'deployed', label: 'Deployed', sortable: true },
    { key: 'deploymentPct', label: 'Deployment', sortable: true },
    { key: 'portfolioCompanies', label: '# Companies', sortable: true },
    { key: 'exitsCount', label: '# Exits', sortable: true },
    { key: 'lpCount', label: 'LPs', sortable: true },
    { key: 'statusBadges', label: 'Status', sortable: true },
];

// ─── Sort field map (column key → API field name) ─────────────────────────────
export const SORT_API_FIELD = {
    name: 'name',
    vintage: 'fund_vintage',
    fundSize: 'target_fund_size',
    deployed: 'direct_estimated_deployed_capital',
    deploymentPct: 'direct_estimated_deployed_capital_percentage',
    portfolioCompanies: 'companies_investedin_count',
    exitsCount: 'number_of_exited_investments',
    lpCount: 'investors_count',
    statusBadges: 'fundraising_status',
};

// ─── API fields requested for the table ──────────────────────────────────────
export const MANAGED_FUNDS_TABLE_FIELDS = [
    'id',
    'name',
    'fund_vintage',
    'target_fund_size',
    'first_close_amount',
    'final_close_amount',
    'fundraising_status',
    'investment_status',
    'deployed_capital',
    'deployed_capital_percentage',
    'direct_estimated_deployed_capital',
    'direct_estimated_deployed_capital_percentage',
    'companies_investedin_count',
    'number_of_exited_investments',
    'investors_data',
    'investedin_fund_verification_status',
    'is_balance_sheet',
];

// ─── Balance sheet ────────────────────────────────────────────────────────────
export const BALANCE_SHEET_FUND_TYPE = 1;
export const BALANCE_SHEET_LABEL = 'Balance Sheet';